import React from "react";
import {
  RefreshCw, Wrench, LifeBuoy, RotateCcw, Gauge,
  Zap, Cpu, Truck, ArrowUpRight,
} from "lucide-react";

const SERVICES = [
  { icon: RefreshCw, title: "Seasonal Tire Changeovers", bullets: ["Summer ↔ Winter", "On-rim swaps", "Fast mobile service"] },
  { icon: Wrench,   title: "Tire Installation",        bullets: ["Mounting", "Balancing", "New tire installation"] },
  { icon: LifeBuoy, title: "Tire Repair",              bullets: ["Flat tire repair", "Puncture repair", "Leak diagnosis"] },
  { icon: RotateCcw,title: "Tire Rotation",            bullets: ["Extend tire life", "Even wear", "Mfr. recommendations"] },
  { icon: Gauge,    title: "Wheel Balancing",          bullets: ["Eliminate vibration", "Improve handling", "Increase tire life"] },
  { icon: Zap,      title: "Roadside Tire Assistance", bullets: ["Flat tire replacement", "Emergency assistance", "Mobile response"] },
  { icon: Cpu,      title: "TPMS Inspection",          bullets: ["Sensor inspection", "Tire pressure check", "Reset service"] },
  { icon: Truck,    title: "Fleet Tire Services",      bullets: ["Contractors & delivery", "Small businesses", "Minimize downtime"] },
];

export const Services = () => {
  return (
    <section id="services" className="section-mv bg-white">
      <div className="container-mv">
        <div className="max-w-2xl">
          <div className="text-xs font-semibold tracking-widest text-brand-red uppercase">Services</div>
          <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-brand-black tracking-tight">
            Everything your tires need — <span className="text-brand-red">without the shop.</span>
          </h2>
          <p className="mt-4 text-neutral-600 text-base leading-relaxed">
            Professional equipment. Certified workmanship. Delivered to your driveway, workplace, or roadside.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICES.map(({ icon: Icon, title, bullets }, i) => (
            <div
              key={title}
              data-testid={`service-card-${i}`}
              className="group relative rounded-xl bg-white border border-neutral-200 p-6 shadow-premium hover:shadow-premium-hover hover:-translate-y-1 hover:border-brand-red/40 transition-[transform,box-shadow,border-color] duration-300"
            >
              <div className="flex items-start justify-between">
                <div className="w-11 h-11 rounded-lg bg-brand-red/10 text-brand-red flex items-center justify-center">
                  <Icon className="w-5 h-5" />
                </div>
                <ArrowUpRight className="w-4 h-4 text-neutral-300 group-hover:text-brand-red transition-colors" />
              </div>
              <h3 className="mt-5 font-display font-bold text-lg text-brand-black">{title}</h3>
              <ul className="mt-3 space-y-1.5">
                {bullets.map((b) => (
                  <li key={b} className="text-sm text-neutral-600 flex items-center gap-2">
                    <span className="w-1 h-1 rounded-full bg-brand-red" /> {b}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
